// extracted by mini-css-extract-plugin
export default {"error_container":"SelectEmailFlowPopup_error_container__13Mlc","error_text":"SelectEmailFlowPopup_error_text__owKGE"};